import {useEffect} from 'react'
import {useLocation} from 'react-router'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {notificationSelector} from 'src/redux/slices/notificationSlices'
import {useNotificationFetcher} from '../../hooks/useNotificationFetcher'

/**
 * Hook ini untuk melakukan fetch notification data setiap kali berpindah page
 * dan menyimpan hasilnya kedalam redux (notificationSelector)
 *
 * @example
 * const state = useNotificationTopbar()
 */
export const useNotificationTopbar = () => {
  const location = useLocation()
  const auth = useAppSelector(authSelector)
  const {isError, isLoading, unreadNotifications} = useAppSelector(notificationSelector)
  const {handleFetchUnreadNotifications} = useNotificationFetcher()

  useEffect(() => {
    handleFetchUnreadNotifications()
  }, [location, auth.credential])

  const refresh = () => { handleFetchUnreadNotifications() }

  return {
    unreadNotifications,
    isLoading,
    isError,
    refresh
  }
}
